import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{page-title (t \"notFound.title\")}}\n\n<h1>{{t \"notFound.title\"}}</h1>",{ moduleName: "walden-trace-app/templates/not-found.hbs" })